import React from 'react';
import { useSelector } from 'react-redux';
import { IM_MESSAGE } from '@/typings/global';
import { GM_AVATAR, GM_NICK } from '@/helpers/userInfo';
import QuestionList from './QuestionList';

function index(props: IM_MESSAGE): JSX.Element {
    const { type, message, ctx } = props;
    const ai_status = useSelector(({ IndexReducer }) => IndexReducer.base_config.game.ai_status);
    const initList = Array.isArray(ctx) ? ctx : [];
    const questionSwiper = {
        'faq-init': (
            <>
                {GM_AVATAR('faq', 'faq')}
                <div className="im-message-block">
                    {GM_NICK('faq', 'faq')}
                    {message && (
                        <div
                            className="im-message-content"
                            dangerouslySetInnerHTML={{ __html: message }}
                        />
                    )}
                    {!_.isEmpty(initList) && ai_status === 0 && (
                        <QuestionList
                            className="im-question-hot"
                            {...props}
                            title="常见问题"
                            initList={initList}
                        />
                    )}
                </div>
            </>
        ),
        'faq-questions': (
            <>
                {GM_AVATAR('faq', 'faq')}
                <div className="im-message-block">
                    {GM_NICK('faq', 'faq')}
                    <QuestionList
                        className="im-question-answer"
                        {...props}
                        title="您可能还关注以下问题"
                        initList={initList}
                    />
                </div>
            </>
        )
    };
    return <li className="im-message-in">{questionSwiper[type]}</li>;
}

export default index;
